
import * as ajax from "../../actions/ajaxCounterActions";
import { getStore } from "../../store/configureStore";
import * as layoutActions from "../../actions/layoutActions";

import simulatieDossierApi from "../../api/simulatieDossierApi";
import bovenLokaliteitPerInfrastructuurApi from "../../api/bovenLokaliteitPerInfrastructuurApi";
import * as exception from "../../actions/exceptionActions";
import GewichtenBLApi from "../../api/gewichtenBLApi";

export default class SimulatieResultaatPageHelper {
    constructor(context, redirector) {
        this.dispatch = getStore().dispatch;
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const subtitle = "Het decreet voor ondersteuning van bovenlokale sportinfrastructuur geeft aan dat een subsidieaanvraag aan 9 minimale eisen moet voldoen en toetsing moet doorstaan die bepaalt of een subsidieaanvraag voldoende bovenlokaal is. De dossiers die deze fase van de procedure doorkomen, worden nadien overhandigd aan een beoordelingscommissie. Via deze simulator kan je nagaan of jouw project voldoende bovenlokaal is en een inschatting maken of aan de minimale eisen kan worden voldaan. Hiervoor gebruik je best de browser 'Google Crome', om foutmeldingen te voorkomen.";
        const simulatieDossierId = this.context.props.simulatieDossierId;

        this.dispatch(layoutActions.loadSimulatieDossierPageLayout("Ontvankelijkheidscriteria", subtitle, simulatieDossierId, false));

        this.dispatch(ajax.started());

        this.getSimulatieDossier(simulatieDossierId);

        this.getPuntenEnGewichten();
    }

    getSimulatieDossier(simulatieDossierId) {
        simulatieDossierApi.get(simulatieDossierId)
            .then(response => {
                this.dispatch(ajax.ended());
                this.context.setState({
                    simulatieDossier: response.data.item,
                    errors: response.data.validationResults
                });
            })
            .catch(error => {
                this.dispatch(ajax.failed(error));
                this.dispatch(exception.throwException(error));
            });
    }

    getPuntenEnGewichten() {
        GewichtenBLApi.get()
            .then(response => {
                this.dispatch(ajax.ended());
                this.context.setState({
                    gewichten: response.data,
                    errors: response.data.validationResults
                });
            })
            .catch(error => {
                this.dispatch(ajax.failed(error));
                this.dispatch(exception.throwException(error));
            });
    }

    wijzig() {
        this.redirector.goTo("/simulatiedossier/" + this.context.state.simulatieDossier.id);
    }

    startDossier() {
        this.redirector.goTo("/aanvraag/simulatie/" + this.context.state.simulatieDossier.id);
    }

    isReadyToRender() {
        // entity not loaded? not ready yet...
        if (!this.context.state.simulatieDossier) {
            return false;
        }

        return true;
    }
}